import { useRef, useEffect, useState } from 'react';
import { getActiveState } from '../helpers/titreHelper';
import { useGetParams } from './useGetParams';
import { useInterval } from './useInterval';

export const useVote = () => {
  const { user } = useGetParams();

  const currentStateRef = useRef(null);
  const isVisibleRef = useRef(null);
  const [voteState, setVoteState] = useState(null);

  const protocol = window?.location.protocol || 'https:';

  const getVoteInfo = async () => {
    try {
      if (!user) {
        return;
      }

      const response = await fetch(
        `${protocol}//stream.iactive.pro/scr/getPollInfo.php?user=${user}`
      );
      const data = await response.json();
      if (!data) return;
      let { visibility, activity } = data;
      // Определяем видимость титра
      const isVisible = Boolean(Number(visibility));
      // const isActivity = Boolean(Number(activity));
      if (!isVisible && isVisible !== isVisibleRef.current) {
        isVisibleRef.current = false;
      } else if (isVisible && isVisible !== isVisibleRef.current) {
        isVisibleRef.current = true;
      }
      // Определяем состояние (S1, S2 ...)
      if (
        data?.state &&
        getActiveState(data?.state) !== currentStateRef.current
      ) {
        currentStateRef.current = getActiveState(data?.state);
      }

      const equal = require('fast-deep-equal');
      if (!equal(voteState, data)) {
        setVoteState(data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getVoteInfo();
  }, []);

  useInterval(() => {
    getVoteInfo();
  }, 1000);

  return {
    currentState: currentStateRef.current,
    isVisible: isVisibleRef.current,
    voteState,
  };
};
